import { BigNumber } from 'bignumber.js';
import { useMemo } from 'react';

import { useAssetPriceQuery } from '../../../api/rates/ratesQueries';

export type UseInxPriceResult = {
  /** INX price in USD */
  inxPrice: BigNumber;
  /** Whether data is still loading */
  isLoading: boolean;
};

/**
 * Hook to get the current INX price using live asset rates.
 */
export function useInxPrice(): UseInxPriceResult {
  const {
    data: inxPriceData,
    isLoading: isInxPriceLoading,
    isSuccess: isInxPriceSuccess,
  } = useAssetPriceQuery({ assetId: 'infinex' });

  return useMemo(() => {
    const livePrice = inxPriceData?.usd?.rate;
    const hasValidLivePrice =
      livePrice !== null &&
      livePrice !== undefined &&
      typeof livePrice === 'number';

    return {
      inxPrice: hasValidLivePrice ? BigNumber(livePrice) : BigNumber(0),
      isLoading: !isInxPriceSuccess || isInxPriceLoading,
    };
  }, [inxPriceData?.usd?.rate, isInxPriceSuccess, isInxPriceLoading]);
}
